import type { Program } from 'models';
import { Modal, message } from 'ui';
import type { Activity } from 'models/activity';
import { ActivityForm } from '../../form';
import { useUpdateActivityMutation } from '../../queries/mutations';

type P = {
  activity: Activity;
  isOpened: boolean;
  onCancel: () => void;
  onSuccess: () => Promise<void>;
  program: Program;
};

const EditActivity = ({ activity, isOpened, onCancel, onSuccess, program }: P) => {
  const { isPending, mutate } = useUpdateActivityMutation();

  const onSubmit = (values: Activity) => {
    mutate(
      { activity: values, routeParams: { id: activity.id } },
      {
        onError() {
          message.error('Failed to update activity.');
        },
        async onSuccess() {
          await onSuccess();
          message.success('Activity was updated.');
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Edit Activity" width="medium">
      <Modal.HugContent>
        <ActivityForm activity={activity} edit loading={isPending} onSubmit={onSubmit} program={program} />
      </Modal.HugContent>
    </Modal>
  );
};

export default EditActivity;
